/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import Cookie from 'js-cookie';

// Core
import ClientApplication from '@client/app';
import type { CoreError } from '@common/errors';

// Core Services
import Router from '@client/services/router';

// App Services
import MetricsService from '@/client/services/metrics';
import ExtensionBridge from '@/client/services/extension';

// App components
import UpgradeModal from '@/client/pages/convert/upgrade/UpgradeModal';

/*----------------------------------
- TYPES
----------------------------------*/


/*----------------------------------
- APPLICATION
----------------------------------*/
export class CrossPath extends ClientApplication {

    public Router = new Router(this, {
        preload: [],

        context: (context, router) => ({
            user: context.user || router.ssrContext.user
        })
    })

    public metrics = new MetricsService(this);

    public Extension = new ExtensionBridge(this);

    public boot(): void {
        // Tracking
        this.Router.on('page.changed', () => {
            this.metrics.event('pageview');
        });

        // Open pgrade modal
        this.Router.on('page.rendered', () => {

            if (Cookie.get('upgraded') === "true") {
                import('@/client/pages/convert/upgrade/UpgradedModal').then(
                    ({ default: UpradeModal }) => this.modal.show(UpradeModal)
                )
            }
        });
    }

    public handleError(error: CoreError) {

        if (error.http === 402) {

            this.modal.show(UpgradeModal, { error });
            
        } else {
        
            const message = ('render' in error && error.render) ? error.render() : error.message;
            this.toast.error( message, undefined, null, { autohide: false });
        }
    }
}

export default CrossPath